export default "__VITE_ASSET__JtoOTwxq__"